import { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import AuthService from '../services/AuthService';

let onUnauthorized: (() => void) | null = null;

export const setOnUnauthorized = (callback: () => void): void => {
  onUnauthorized = callback;
};

export const requestAuthInterceptor = async (
  config: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> => {
  const token = await AuthService.shared.getCredentials();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

export const requestErrorInterceptor = (error: AxiosError): Promise<never> => {
  return Promise.reject(error);
};

export const responseSuccessInterceptor = (response: AxiosResponse): AxiosResponse => {
  return response;
};

export const responseErrorInterceptor = async (error: AxiosError): Promise<unknown> => {
  if (error.response?.status === 401) {
    await AuthService.shared.removeCredentials();
    return onUnauthorized?.();
  }
  return Promise.reject(error);
};
